import { Tchek } from './tchek';
import { Company } from './company';

export class Folder {
  id: string;
  name: string;
  totalPictures: number;
  tchek: Tchek;
  descCam: string;
  company: Company;

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/model/folder.ts